<template>
  <b-card title="رزروهای مشاوره">
    <b-row>
      <b-col class="table-size">
        <div class="custom-search">
          <b-row>
            <div class="filter-row">
              <b-col md="2">
                <b-form-group
                  label="موبایل کاربر"
                  label-for="Mobile"
                >
                  <b-form-input
                    v-model="filterOptions.Mobile"
                    @keyup.enter="update(1)"
                  />
                </b-form-group>
              </b-col>
              <b-col md="2">
                <b-form-group
                  label="وضعیت"
                  label-for="Status"
                >
                  <v-select
                    v-model="filterOptions.Status"
                    :options="statusOptions"
                    dir="rtl"
                    label="text"
                    :reduce="x => x.value"
                  />
                </b-form-group>
              </b-col>
              <b-col md="2">
                <b-form-group
                  label="روش"
                  label-for="Method"
                >
                  <v-select
                    v-model="filterOptions.Method"
                    :options="methodOptions"
                    dir="rtl"
                    label="text"
                    :reduce="x => x.value"
                  />
                </b-form-group>
              </b-col>
              <b-button
                v-ripple.400="'rgba(186, 191, 199, 0.15)'"
                class="mb-1 mr-1"
                variant="warning"
                @click="update(1)"
              >فیلتر
              </b-button>
            </div>
          </b-row>
        </div>

        <b-table
          bordered
          hover
          striped
          :items="items"
          :fields="fields"
          class="mt-1 mb-2 position-relative"
          responsive
          :busy="loading"
        >
          <template #cell(Id)="data">
            <b-link
              class="font-weight-bold"
              @click="openDetails(data.item.Id)"
            >
              #{{ data.value }}
            </b-link>
          </template>

          <template #cell(Consultant)="data">
            <span>{{ (data.item.ConsultantName || '') + ' ' + (data.item.ConsultantFamily || '') }}</span>
          </template>

          <template #cell(Client)="data">
            <div>
              <div>{{ (data.item.ClientName || '') + ' ' + (data.item.ClientFamily || '') }}</div>
              <small class="text-muted">{{ data.item.ClientMobile }}</small>
            </div>
          </template>

          <template #cell(Method)="data">
            <b-badge variant="light-info">{{ methodText(data.value) }}</b-badge>
          </template>

          <template #cell(StartAt)="data">
            <span class="text-nowrap">{{ data.value | date('date-time') }}</span>
          </template>

          <template #cell(Price)="data">
            <span class="text-nowrap">{{ money(data.value) }}</span>
          </template>

          <template #cell(Status)="data">
            <b-badge :variant="statusVariant(data.value)">{{ statusText(data.value) }}</b-badge>
          </template>

          <template #cell(actions)="data">
            <feather-icon
              icon="EyeIcon"
              size="16"
              class="cursor-pointer"
              @click="openDetails(data.item.Id)"
            />
          </template>

          <template #table-busy>
            <div class="text-center my-2">
              <b-spinner
                variant="primary"
                class="align-middle"
              />
              <strong class="ml-1">در حال دریافت اطلاعات ...</strong>
            </div>
          </template>
        </b-table>

        <z-pagination
          :page="filterOptions.Page"
          :per-page.sync="filterOptions.PerPage"
          :total-rows="totalRows"
          :loading="loading"
          @change="update"
        />
      </b-col>
    </b-row>

    <b-modal
      v-if="showModal"
      v-model="showModal"
      centered
      hide-footer
      title="جزئیات رزرو"
      :no-close-on-backdrop="true"
      size="lg"
    >
      <div
        v-if="detailLoading"
        class="text-center my-3"
      >
        <b-spinner variant="primary" />
      </div>

      <div v-else-if="detail">
        <b-row>
          <b-col
            md="6"
            class="mb-1"
          >
            <small class="text-muted">مشاور</small>
            <div class="font-weight-bold">{{ detail.ConsultantName }} {{ detail.ConsultantFamily }}</div>
          </b-col>
          <b-col
            md="6"
            class="mb-1"
          >
            <small class="text-muted">کاربر</small>
            <div class="font-weight-bold">{{ detail.ClientName }} {{ detail.ClientFamily }} - {{ detail.ClientMobile }}</div>
          </b-col>
          <b-col
            md="4"
            class="mb-1"
          >
            <small class="text-muted">روش</small>
            <div><b-badge variant="light-info">{{ methodText(detail.Method) }}</b-badge></div>
          </b-col>
          <b-col
            md="4"
            class="mb-1"
          >
            <small class="text-muted">مدت</small>
            <div class="font-weight-bold">{{ detail.DurationMinutes }} دقیقه</div>
          </b-col>
          <b-col
            md="4"
            class="mb-1"
          >
            <small class="text-muted">وضعیت</small>
            <div><b-badge :variant="statusVariant(detail.Status)">{{ statusText(detail.Status) }}</b-badge></div>
          </b-col>
          <b-col
            md="4"
            class="mb-1"
          >
            <small class="text-muted">مبلغ کل</small>
            <div class="font-weight-bold">{{ money(detail.Price) }} تومان</div>
          </b-col>
          <b-col
            md="4"
            class="mb-1"
          >
            <small class="text-muted">کمیسیون پلتفرم</small>
            <div class="font-weight-bold">{{ money(detail.CommissionAmount) }} تومان</div>
          </b-col>
          <b-col
            md="4"
            class="mb-1"
          >
            <small class="text-muted">سهم مشاور</small>
            <div class="font-weight-bold">{{ money(detail.ConsultantShare) }} تومان</div>
          </b-col>
          <b-col
            md="6"
            class="mb-1"
          >
            <small class="text-muted">شروع</small>
            <div class="font-weight-bold">{{ detail.StartAt | date('date-time') }}</div>
          </b-col>
          <b-col
            md="6"
            class="mb-1"
          >
            <small class="text-muted">پایان</small>
            <div class="font-weight-bold">{{ detail.EndAt | date('date-time') }}</div>
          </b-col>
          <b-col
            md="4"
            class="mb-1"
          >
            <small class="text-muted">منبع پرداخت</small>
            <div class="font-weight-bold">{{ detail.PaymentSource === 0 ? 'کیف‌پول' : 'درگاه' }}</div>
          </b-col>
          <b-col
            md="4"
            class="mb-1"
          >
            <small class="text-muted">تاریخ ثبت</small>
            <div class="font-weight-bold">{{ detail.CreatedAt | date('date-time') }}</div>
          </b-col>
          <b-col
            v-if="detail.PaidAt"
            md="4"
            class="mb-1"
          >
            <small class="text-muted">تاریخ پرداخت</small>
            <div class="font-weight-bold">{{ detail.PaidAt | date('date-time') }}</div>
          </b-col>
          <b-col
            v-if="detail.CompletedAt"
            md="4"
            class="mb-1"
          >
            <small class="text-muted">تاریخ تکمیل</small>
            <div class="font-weight-bold">{{ detail.CompletedAt | date('date-time') }}</div>
          </b-col>
          <b-col
            v-if="detail.CancelledAt"
            md="4"
            class="mb-1"
          >
            <small class="text-muted">تاریخ لغو</small>
            <div class="font-weight-bold">{{ detail.CancelledAt | date('date-time') }}</div>
          </b-col>
          <b-col
            v-if="detail.CancelReason"
            md="12"
            class="mb-1"
          >
            <small class="text-muted">دلیل لغو</small>
            <div class="text-danger">{{ detail.CancelReason }}</div>
          </b-col>
        </b-row>
      </div>
    </b-modal>
  </b-card>
</template>

<script>
export default {
  name: 'ConsultingBooking',
  data() {
    return {
      totalRows: 1000 * 1000,
      loading: false,
      filterOptions: {
        Mobile: null,
        Status: null,
        Method: null,
        Page: 1,
        PerPage: 10,
      },
      statusOptions: [
        { text: 'در انتظار پرداخت', value: 0 },
        { text: 'پرداخت‌شده', value: 1 },
        { text: 'تکمیل‌شده', value: 2 },
        { text: 'لغو توسط کاربر', value: 3 },
        { text: 'لغو توسط مشاور', value: 4 },
        { text: 'منقضی‌شده', value: 5 },
      ],
      methodOptions: [
        { text: 'تماس تلفنی', value: 0 },
        { text: 'تماس تصویری', value: 1 },
        { text: 'چت متنی', value: 2 },
        { text: 'حضوری', value: 3 },
      ],
      items: [],
      showModal: false,
      detail: null,
      detailLoading: false,
      fields: [
        { key: 'Id', label: '#', thClass: 'col-width-50' },
        { key: 'Consultant', label: 'مشاور' },
        { key: 'Client', label: 'کاربر' },
        { key: 'Method', label: 'روش' },
        { key: 'StartAt', label: 'شروع' },
        { key: 'Price', label: 'مبلغ (تومان)' },
        { key: 'Status', label: 'وضعیت' },
        { key: 'actions', label: '', thClass: 'col-width-50' },
      ],
    }
  },
  created() {
    if (this.$store.state.zirehState.listFilter[this.$options.name]) {
      this.filterOptions = this.$store.state.zirehState.listFilter[this.$options.name]
    }
    this.update()
  },
  methods: {
    money(value) {
      if (value == null) return '۰'
      return Number(value).toLocaleString('fa-IR')
    },
    methodText(value) {
      return ['تماس تلفنی', 'تماس تصویری', 'چت متنی', 'حضوری'][value] || '—'
    },
    statusText(value) {
      return ['در انتظار پرداخت', 'پرداخت‌شده', 'تکمیل‌شده', 'لغو توسط کاربر', 'لغو توسط مشاور', 'منقضی‌شده'][value] || '—'
    },
    statusVariant(value) {
      return ['light-warning', 'light-success', 'light-primary', 'light-danger', 'light-danger', 'light-secondary'][value] || 'light-secondary'
    },
    update(pageNumber) {
      this.loading = true
      this.filterOptions.Page = pageNumber || this.filterOptions.Page
      this.$store.commit('zirehState/setListFilter', { key: this.$options.name, value: this.filterOptions })

      this.$http.post(this.$api.consultingbooking.getlist, this.filterOptions)
        .then(res => {
          this.totalRows = res.totalRow
          this.items = res.data
        })
        .finally(() => {
          this.loading = false
        })
    },
    openDetails(id) {
      this.showModal = true
      this.detail = null
      this.detailLoading = true
      this.$http.post(this.$api.consultingbooking.get, { Id: id })
        .then(res => {
          this.detail = res.data
        })
        .finally(() => {
          this.detailLoading = false
        })
    },
  },
}
</script>
